import { API_URL } from "../config";

const originalFetch = window.fetch;

window.fetch = async (...args) => {
    let [resource, config] = args;

    // Skip refresh token request to avoid infinite loop
    if (typeof resource === 'string' && resource.includes('/auth/refresh')) {
        return originalFetch(...args);
    }

    let response = await originalFetch(...args);

    if (response.status === 401) {
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken) {
            try {
                const refreshResponse = await originalFetch(`${API_URL}/auth/refresh`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ refresh_token: refreshToken }),
                });

                if (refreshResponse.ok) {
                    const data = await refreshResponse.json();
                    localStorage.setItem("access_token", data.access_token);
                    if (data.refresh_token) {
                        localStorage.setItem("refresh_token", data.refresh_token);
                    }

                    // Retry the original request with the new token
                    const newConfig = { ...(config || {}) };
                    newConfig.headers = {
                        ...(newConfig.headers || {}),
                        'Authorization': `Bearer ${data.access_token}`
                    };
                    return originalFetch(resource, newConfig);
                } else {
                    // Refresh failed - clear tokens and redirect to login
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("refresh_token");
                    // Only redirect if not already on the login page
                    if (window.location.pathname !== '/') {
                        window.location.href = "/";
                    }
                }
            } catch (err) {
                console.error("Token refresh failed", err);
            }
        }
    }

    return response;
};
